export default "__VITE_ASSET__NzXmiNVL__"